<template>
    <div v-if="team" class="relative z-0 flex flex-col flex-grow px-6 py-6 bg-gray-50">
        <app-header>
            <h2 class="flex justify-start flex-1 text-2xl font-bold text-gray-800">{{ team.name }}</h2>
        </app-header>
        <team-content-header :users="team.users" :id="team.id" />
        <team-announcement-footer v-if="activeAnnouncement !== undefined && notSeen" @seen="markSeen" :announcement="activeAnnouncement" />
        <router-view :team="team" v-if="!$store.getters['flows/isFetching']" />
    </div>
</template>

<script>
import AppHeader from '@/views/AppHeader';
import TeamContentHeader from '@/components/TeamContentHeader';
import TeamAnnouncementFooter from '@/components/TeamAnnouncementFooter';

export default {
    name: 'app-team',
    components: { AppHeader, TeamContentHeader, TeamAnnouncementFooter },
    metaInfo() {
        if (this.team) {
            return {
                title: this.team.name,
            };
        }
        return {
            titleTemplate: null,
        };
    },
    computed: {
        team() {
            return this.$store.state.teams.all.find(team => team.id === parseInt(this.$route.params.id));
        },
        activeAnnouncement() {
            if (this.team) {
                try {
                    return this.$store.state.announcements.all.find(a => a.team.id === this.team.id && a.active === true);
                } catch (err) {
                    return undefined;
                }
            } else {
                return undefined;
            }
        },
        notSeen() {
            const seen_announcements = JSON.parse(localStorage.getItem('_seen') || '[]');
            return !seen_announcements.includes(this.activeAnnouncement.id);
        },
    },
    methods: {
        markSeen(id) {
            const seen_announcements = JSON.parse(localStorage.getItem('_seen') || '[]');
            return localStorage.setItem('_seen', JSON.stringify(seen_announcements.concat(id)));
        },
    },
    mounted() {
        this.$store.dispatch('flows/all_org');
        this.$store.dispatch('announcements/all_org');
    },
};
</script>
